import axios from 'axios';

// À mettre à jour avec l'url d'upload nécessaire
const API_URL = process.env.VUE_APP_API_URL;

// Upload file
const upload = async (file, handleUploadProgress) => {
  const formData = new FormData();
  formData.append('file', file);

  try {
    const response = await axios.post(
      `${API_URL}/public/orthodontic-simulation`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: handleUploadProgress,
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

const get = async (predictionId) => {
  try {
    const response = await axios.get(
      `${API_URL}/public/orthodontic-simulation/${predictionId}`,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

const api = {};
api.upload = upload;
api.get = get;

export default api;
